export const NABEDGE = 'NABEDGE';

export const AUTH_CLIENT_ID = {
    sit1: '69DFCFB4-4DA9-9202-5D35-7AEFA8EF0083',
    sit4: '69676AF5-9146-247E-BBD2-B15E6176439A',
    sit5: '6977F464-7ABF-F6F0-DD9B-36A31722D3C8'
};
